import React from "react";
import BarcodeScanner from "../../components/barcode-scanner";
import Page from "../../components/page";

export default function() {
  const { history } = this.props;
  const { url, detected } = this.state;
  return (
    <Page header="Scanner">
      <BarcodeScanner
        onDetect={({ codeResult }) => {
          if (!detected && codeResult) {
            if(this.state.courierNumber === ''){
              this.setState({ detected: true, courierNumber: codeResult.code});
            }else{
              this.setState({ detected: true, courierNumber2: codeResult.code});
            }
            history.replace(`${url}/${codeResult.code}`);
          }
        }}
      />
    </Page>
  );
}



// WEBPACK FOOTER //
// ./src/screens/scanner/view.js